import { MESApiService, spParameter } from "@dexteel/mesf-core";
import { get } from "lodash-es";
import type { RMShiftReportRow } from "../models/RMShiftReport";

export const getRMShiftReport = async ({
	start,
	end,
	signal,
}: {
	start: string;
	end: string;
	signal?: AbortSignal;
}): Promise<RMShiftReportRow[]> => {
	const apiService = new MESApiService();
	const parameters: spParameter[] = [
		{ name: "Start", value: start },
		{ name: "End", value: end },
	];

	const resp = await apiService.callV2(
		"[MILL].[GetRMShiftReport]",
		parameters,
		signal,
	);

	if (resp.ok) {
		return get(resp, "data.tables[0].rows", []);
	}
	throw new Error(resp.message || "Error fetching RM Shift Report");
};
